module.exports = __webpack_public_path__ + "static/media/Mellotron.bdcf7f47.png";